module.exports = __webpack_public_path__ + "img/slide8.1a2b62bd.png";